import * as notificationsCoordinators from './notifications'

export default Object.freeze({
  ...notificationsCoordinators,
})
